import React from 'react';
import {
  Table,
  Input,
  Button,
  Space,
  Skeleton,
  Row,
  Col,
  Card,
  Select,
  Form
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import moment from 'moment';
import { GlobalApiErrorHandler } from '../../shared/helpers';
import { reqGetRetrieveAllJobs } from '../../axios/api';

const { Option } = Select;

export class JobList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    tableData: [],
    filterTable: null,
    showMoreOptions: false,
    jobTitles: null,
    searchValue: null,
    titleSearchValue: null,
    titleSearchValue: null,
    countryNames: null,
  };

  componentDidMount = () => {
    reqGetRetrieveAllJobs()
      .then(res => {
        var data = res.data;

        data.map((item, i) => {
          data[i].title = item.jobTitleName;
          data[i].locationFormatted = item.jobPostingCity + ", " + (item.jobPostingStateName ? item.jobPostingStateName + ", " : "") + item.jobPostingCountryName;
          data[i].postingDateFormatted = moment(item.startDt).format('MM/DD/YYYY');
        });

        const uniqueJobTitles = [...new Set(res.data.map(item => item.title))];
        const uniqueCountryNames = [...new Set(res.data.map(item => item.jobPostingCountryName))];

        this.setState({
          jobTitles: uniqueJobTitles,
          countryNames: uniqueCountryNames
        });

        this.setState({
          tableData: data
        });
      }).catch(err => {
        console.log(err);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => { this.handleSearch(selectedKeys, confirm, dataIndex); console.log(dataIndex) }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        text ? text.toString() : ''
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  onClickJobTitle = (e, data) => {
    e.preventDefault();

    this.props.history.push({
      pathname: '/job-item/' + data.jobPostingID + "/" + data.jobTitleName,
      //search: "?jobPostingID=" + data.jobPostingID
    });
  }

  filter = (general = "", title = "", country = "") => {
    const { tableData } = this.state;
    var filterTable = tableData;

    if (general) {
      filterTable = filterTable.filter(o =>
        Object.keys(o).some(k =>
          String(o[k])
            .toLowerCase()
            .includes(general.toLowerCase())
        )
      );
    }

    if (title) {
      filterTable = filterTable.filter((item, i) => {
        return item.title === title;
      });
    }

    if (country) {
      filterTable = filterTable.filter((item, i) => {
        return item.jobPostingCountryName.toLowerCase() === country.toLowerCase();
      });
    }

    return this.setState({
      filterTable: filterTable,
    });
  }

  search = value => {
    this.setState({
      searchValue: value
    });

    this.filter(value, this.state.titleSearchValue, this.state.countrySearchValue);
  };

  handleCountrySearch = value => {
    this.setState({
      countrySearchValue: value
    });

    this.filter(this.state.searchValue, this.state.titleSearchValue, value);
  }

  handleTitleFilter = value => {
    this.setState({
      titleSearchValue: value
    });

    this.filter(this.state.searchValue, value, this.state.countrySearchValue);
  };

  resetCustomFilters = (e) => {
    e.preventDefault();

    this.setState({
      searchValue: "",
      titleSearchValue: "",
      countrySearchValue: "",
      filterTable: null,
    });
  }

  render() {
    const columns = [
      {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
        width: '30%',
        ...this.getColumnSearchProps('title'),
        sorter: (a, b) => a.title.localeCompare(b.title),
        sortDirections: ['descend', 'ascend'],
        render: (text, row) => <a href="#" onClick={(e) => { this.onClickJobTitle(e, row) }}>{text}</a>
      },
      {
        title: 'Location',
        dataIndex: 'locationFormatted',
        key: 'locationFormatted',
        width: '40%',
        sorter: (a, b) => a.title.localeCompare(b.title),
        sortDirections: ['descend', 'ascend'],
        ...this.getColumnSearchProps('locationFormatted'),
      },
      {
        title: 'Posting Date',
        dataIndex: 'postingDateFormatted',
        key: 'postingDateFormatted',
        sorter: (a, b) => moment(a.postingDateFormatted).unix() - moment(b.postingDateFormatted).unix(),
        ...this.getColumnSearchProps('postingDateFormatted'),
      },
    ];

    return (
      <>
        {
          this.state.tableData && this.state.tableData.length > 0 ?
            <>
              <div className="search-rows">
                <Row>
                  <Col xs={24} md={12}>
                    <Input.Search
                      //style={{width: "100%"} }
                      placeholder="Search by keyword"
                      enterButton="Search Jobs"
                      onChange={e => this.setState({ searchValue: e.target.value })}
                      onSearch={this.search}
                      value={this.state.searchValue}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={24} md={12}>
                    <Button onClick={e => {
                      e.preventDefault();
                      this.setState({ showMoreOptions: !this.state.showMoreOptions });
                    }}>
                      {this.state.showMoreOptions ? "Show less options" : "Show more options"}
                    </Button>
                    {" "}
                    <Button onClick={this.resetCustomFilters}>
                      Reset
                    </Button>
                  </Col>
                </Row>

                {
                  this.state.showMoreOptions && (
                    <Row>
                      <Col xs={24}>
                        <Card>
                          <Row>
                            <Col md={11}>
                              <Row>
                                <Col md={2} xs={24}>
                                  <label>Title</label>
                                </Col>

                                <Col md={22} xs={24}>
                                  <Select
                                    showSearch
                                    placeholder="Search to Select"
                                    style={{ width: "100%" }}
                                    onChange={this.handleTitleFilter}
                                    value={this.state.titleSearchValue}
                                  >
                                    {
                                      this.state.jobTitles && this.state.jobTitles.map((item, i) => {
                                        return (
                                          <Option key={i} value={item}>{item}</Option>
                                        )
                                      })
                                    }
                                  </Select>
                                </Col>
                              </Row>
                            </Col>

                            <Col md={{ span: 11, offset: 1 }}>
                              <Row>
                                <Col md={3} xs={24}>
                                  <label>Country</label>
                                </Col>

                                <Col md={21} xs={24}>
                                  <Select
                                    showSearch
                                    placeholder="Search to Select"
                                    style={{ width: "100%" }}
                                    onChange={this.handleCountrySearch}
                                    value={this.state.countrySearchValue}
                                  >
                                    {
                                      this.state.countryNames && this.state.countryNames.map((item, i) => {
                                        return (
                                          <Option key={i} value={item}>{item}</Option>
                                        )
                                      })
                                    }
                                  </Select>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  )
                }
              </div>

              <Row>
                <Col md={24} xs={24}>
                  <Table
                    columns={columns}
                    dataSource={this.state.filterTable === null ? this.state.tableData : this.state.filterTable}
                    pagination={{ defaultPageSize: 5, showSizeChanger: true, pageSizeOptions: ['5', '10', '20'] }}
                    rowKey='jobPostingID'
                    onChange={this.handleTableChange}
                  //searchableProps={{ fuzzySearch: true }}
                  />
                </Col>
              </Row>
            </>
            :
            <Skeleton active />
        }
      </>
    );
  }
}
